import * as React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

interface Props {
  children?: React.JSX.Element;
}

const ThemeWrapper: React.FC<Props> = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={patientAccessTheme}>{children}</ThemeProvider>
  </StyledEngineProvider>
);

export default ThemeWrapper;
